// extracted by mini-css-extract-plugin
export default {"blockContainer":"DownloadFile_blockContainer__LyQej"};